import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { LocalizationProvider } from '@material-ui/pickers';
import MomentUtils from '@material-ui/pickers/adapter/moment';
import Env from '@opsbase/lib-env';
import Pages from '@opsbase/lib-pages';
import App from '@opsbase/lib-system/App';
import I18nProvider from '@opsbase/react-i18nprovider';
import WebApp from '@opsbase/web-app';
import { Apollo, ApolloProvider } from '@opsbase/web-app-apollo';
import { setAppVersionForDisplay } from '@opsbase/web-app/AppPage';
import ga from '@opsbase/web-app/modules/ga';
import Router from '@opsbase/web-app/modules/router';
import * as Sentry from '@sentry/react';
import * as SentryTracing from '@sentry/tracing';
import moment from 'moment-timezone';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import hero from '../shared/assets/images/hero.png';
import logoBlack from '../shared/assets/images/logo-black.svg';
import logoOnly from '../shared/assets/images/logo-only.png';
import logo from '../shared/assets/images/logo.svg';
import nls from '../shared/assets/nls/basicNls';
import { AppNavs } from './navs';
import { AppRoutes, defaultRouteFor, getSpecialRouteFor } from './routes';
import { theme } from './theme';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { version } = require('../../version.json');
setAppVersionForDisplay(version);
if (!Env.dev) {
    Sentry.init({
        dsn: 'https://d745bada9af04b1780243adadeb098e7@o372827.ingest.sentry.io/6175321',
        integrations: [new SentryTracing.Integrations.BrowserTracing()],
        environment: Env.envName,
        tracesSampleRate: 1.0,
    });
}
moment.relativeTimeThreshold('m', 59);
ga.init('webapp', Pages);
const root = document.createElement('div');
document.body.appendChild(root);
const render = Component => {
    ReactDOM.render(React.createElement(LocalizationProvider, { dateLibInstance: moment, dateAdapter: MomentUtils },
        React.createElement(MuiThemeProvider, { theme: theme },
            React.createElement(CssBaseline, null),
            React.createElement(ApolloProvider, { client: Apollo },
                React.createElement(I18nProvider, { enableLoader: true, nls: nls },
                    React.createElement(AppContainer, null,
                        React.createElement(Component, null)))))), root);
};
const routedApp = Router(() => (React.createElement(WebApp, { logo: logo, logoOnly: logoOnly, logoBlack: logoBlack, hero: hero, rootDiv: root, app: App.OPSBASE, routes: AppRoutes, navs: AppNavs, hasAlerts: true, hasSupport: true, getSpecialRouteFor: getSpecialRouteFor, defaultRouteFor: defaultRouteFor })));
render(routedApp);
if (module['hot']) {
    module['hot'].accept('@opsbase/web-app/modules/router', () => {
        render(routedApp);
    });
}
